<mat-dialog-content>
  <p>Selecionar colaborador</p>
</mat-dialog-content>
<mat-form-field class="flex flex-col min-width-select">
  <mat-select [ngModel]="selectedCollaboratorId"
    (ngModelChange)="onSelectChange($event)">
    @for (option of options; track option) {
      <mat-option [value]="option.value">
        {{option.label}}
      </mat-option>
    }
    @if (isUsersDropdownLoading) {
      <mat-option disabled>A carregar utilizadores...</mat-option>
    }
  </mat-select>
</mat-form-field>
<mat-dialog-actions align="center">
  <button mat-stroked-button class="dialog-btn" [disabled]="isUsersDropdownLoading" [mat-dialog-close]="false">Cancelar</button>
  <button mat-flat-button class="dialog-btn" [disabled]="isUsersDropdownLoading" [color]="'primary'" [mat-dialog-close]="selectedCollaboratorId">Ok</button>
</mat-dialog-actions>
